export default "__VITE_ASSET__BGA8x$jK__"